import { Get_Token } from 'resolvers/Get_Token';
import baseService from './apiService';

export const totalRewards = async () => {
    const response = await baseService.get('/rewards/total', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const RewardsHistory = async ({ type = '', page = 0, limit = 10 }) => {
    const response = await baseService.get('/rewards/', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: {
            type,
            page,
            limit
        }
    });
    return response.data;
};

export const postRedemptionAttempt = async () => {
    const response = await baseService.post(
        '/rewards/redemption',
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
};
